export default {
  SUBDOMES_MGMT_LIST_REQUEST: 'APP/SUBDOMES_MGMT/SUBDOMES_MGMT_LIST_REQUEST',
  SUBDOMES_MGMT_LIST_SUCCESS: 'APP/SUBDOMES_MGMT/SUBDOMES_MGMT_LIST_SUCCESS',
  SUBDOMES_MGMT_LIST_ERROR: 'APP/SUBDOMES_MGMT/SUBDOMES_MGMT_LIST_ERROR',
};
